import React from 'react';
import { SearchProvider } from "v4/contexts/SearchContext/SearchContext";
import { PROSPECT_CONTACTS_SEARCH_FORM } from "v4/data/apiRoutes";
import { CONTACT, QUOTE, TASK } from "v4/data/entities";
import SecondaryNavigation from "v4/features/front/navigation/components/SecondaryNavigation/SecondaryNavigation";
import { useNavigation } from "v4/features/front/navigation/contexts/NavigationContext";
import ProspectClosedTasksTab
    from "v4/pages/front/Prospect/components/ProspectTabsSwitcher/components/ProspectClosedTasksTab/ProspectClosedTasksTab";
import ProspectContactsCustomTab
    from "v4/pages/front/Prospect/components/ProspectTabsSwitcher/components/ProspectContactsCustomTab/ProspectContactsCustomTab";
import ProspectContactsTab
    from "v4/pages/front/Prospect/components/ProspectTabsSwitcher/components/ProspectContactsTab/ProspectContactsTab";
import ProspectOldMailTasksTab
    from "v4/pages/front/Prospect/components/ProspectTabsSwitcher/components/ProspectOldMailTasksTab/ProspectOldMailTasksTab";
import ProspectOpenTasksTabResume
    from "v4/pages/front/Prospect/components/ProspectTabsSwitcher/components/ProspectOpenTasksTab/components/ProspectOpenTasksTabResume/ProspectOpenTasksTabResume";
import ProspectOpenTasksTab
    from "v4/pages/front/Prospect/components/ProspectTabsSwitcher/components/ProspectOpenTasksTab/ProspectOpenTasksTab";
import ProspectQuotesCustomTab
    from "v4/pages/front/Prospect/components/ProspectTabsSwitcher/components/ProspectQuotesCustomTab/ProspectQuotesCustomTab";
import ProspectQuotesTab
    from "v4/pages/front/Prospect/components/ProspectTabsSwitcher/components/ProspectQuotesTab/ProspectQuotesTab";
import ProspectReceivedMailsTasksTab
    from "v4/pages/front/Prospect/components/ProspectTabsSwitcher/components/ProspectReceivedMailsTasksTab/ProspectReceivedMailsTasksTab";
import ProspectStats360Tab
    from "v4/pages/front/Prospect/components/ProspectTabsSwitcher/components/ProspectStats360Tab/ProspectStats360Tab";
import ProspectTasksCustomTab
    from "v4/pages/front/Prospect/components/ProspectTabsSwitcher/components/ProspectTasksCustomTab/ProspectTasksCustomTab";
import ProspectWonQuotesTab
    from "v4/pages/front/Prospect/components/ProspectTabsSwitcher/components/ProspectWonQuotesTab/ProspectWonQuotesTab";
import 'v4/pages/front/Prospect/components/ProspectTabsSwitcher/ProspectTabsSwitcher.scss';
import { Error404 } from "views/Error/404";
import QuoteTabProvider from "./contexts/QuoteTabContext";

export default function ProspectTabsSwitcher() {
    const { currentRoute } = useNavigation();

    const isEditPage = currentRoute.routeType === 'EDIT';
    const isAddPage = currentRoute.routeType === 'ADD';

    return (
        <div className={`prospect__tab ${(isEditPage || isAddPage) ? 'no-overflow' : ''}`}>
            <SecondaryNavigation />
            <div className="prospect__tab__component">
                <SearchProvider key={currentRoute.route.url}
                    searchRouteName={getSearchRouteName(currentRoute.route.search_type)}
                    pageType={currentRoute.route.slug}>
                    {getTabComponent(
                        currentRoute.route.native_identifier,
                        currentRoute.isCustomTab,
                        currentRoute.route.search_type,
                    )}
                </SearchProvider>
            </div>
        </div>
    );
}

function getTabComponent(nativeIdentifier, isCustomTab, searchType) {
    if (isCustomTab) {
        switch (searchType) {
            case CONTACT:
                return <ProspectContactsCustomTab />;
            case QUOTE:
                return <QuoteTabProvider><ProspectQuotesCustomTab /></QuoteTabProvider>;
            case TASK:
                return <ProspectTasksCustomTab />;
            default:
                return null;
        }
    }

    switch (nativeIdentifier) {
        case 'detail_contacts':
            return <ProspectContactsTab />
        case 'detail_open_tasks':
            return <ProspectOpenTasksTab />
        case 'detail_closed_tasks':
            return <ProspectClosedTasksTab />
        case 'detail_mail_history':
            return <ProspectOldMailTasksTab />
        case 'detail_received_mails':
            return <ProspectReceivedMailsTasksTab />
        case 'detail_quotes':
            return <QuoteTabProvider><ProspectQuotesTab /></QuoteTabProvider>
        case 'detail_won_quotes':
            return <QuoteTabProvider><ProspectWonQuotesTab /></QuoteTabProvider>
        case 'detail_stats_360':
            return <ProspectStats360Tab />;
        case 'detail_resume_tasks':
            return <ProspectOpenTasksTabResume />;
        case 'detail_not_found':
        default:
            return <Error404/>;
    }
}

function getSearchRouteName(searchType) {
    switch (searchType) {
        case CONTACT:
            return PROSPECT_CONTACTS_SEARCH_FORM;
        default:
            return undefined;
    }
}
